import { modalResolvePartiallyEditSubtitle } from "_constants";
import { Divider } from "primereact/divider";

export const ModalResolveReportPartiallyWrongHeader = ({
  reportCode,
}: {
  reportCode: string;
}) => {
  return (
    <>
      <h4 className="header-title margin-bottom-4">{reportCode}</h4>
      <span className="text-base-regular">
        {modalResolvePartiallyEditSubtitle}
      </span>
      <Divider className="margin-top-24 margin-bottom-0 divider-header-edit-answer" />
    </>
  );
};
